// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-69d426b7]{justify-content:center;height:50px}.registration[data-v-69d426b7]{overflow-y:scroll;height:100vh}.registration_attachment[data-v-69d426b7]{width:1200px;margin:0 auto;margin-top:50px;padding-bottom:50px;box-sizing:content-box}.footer[data-v-69d426b7],.mobile-footer[data-v-69d426b7]{margin-top:50px;width:100%}@media only screen and (max-width:768px){.registration_attachment[data-v-69d426b7]{width:100%;padding:15px 15px 100px 15px}}", ""]);
// Exports
module.exports = exports;
